import { jsx as _jsx } from "react/jsx-runtime";
const SvgStreamPlatformTiktok = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "Icons",
		children: /* @__PURE__ */ _jsx("g", {
			id: "StreamingPlatform",
			children: /* @__PURE__ */ _jsx("g", {
				id: "Platform=TikTok",
				children: /* @__PURE__ */ _jsx("path", {
					id: "Vector",
					d: "M29 10V15C29 15.2652 28.8946 15.5196 28.7071 15.7071C28.5196 15.8946 28.2652 16 28 16C25.911 16.0049 23.8521 15.5026 22 14.5363V19.5C22 22.0196 20.9991 24.4359 19.2175 26.2175C17.4359 27.9991 15.0196 29 12.5 29C9.98044 29 7.56408 27.9991 5.78249 26.2175C4.00089 24.4359 3 22.0196 3 19.5C3 14.8875 6.36375 10.81 10.825 10.015C10.9689 9.98942 11.1167 9.9957 11.2579 10.0334C11.3992 10.0711 11.5304 10.1393 11.6424 10.2332C11.7544 10.3271 11.8445 10.4445 11.9063 10.5769C11.9681 10.7094 12.0001 10.8538 12 11V16.3363C12.0001 16.5255 11.9464 16.7109 11.8453 16.8709C11.7442 17.0309 11.5997 17.1589 11.4288 17.24C11.0245 17.4317 10.6792 17.7283 10.4287 18.099C10.1782 18.4696 10.0317 18.9007 10.0046 19.3472C9.97747 19.7938 10.0707 20.2394 10.2744 20.6376C10.4782 21.0359 10.7851 21.3722 11.1631 21.6114C11.5411 21.8506 11.9764 21.984 12.4236 21.9977C12.8707 22.0114 13.3133 21.9048 13.7053 21.6891C14.0972 21.4735 14.4241 21.1566 14.6518 20.7715C14.8796 20.3865 14.9998 19.9474 15 19.5V3C15 2.73478 15.1054 2.48043 15.2929 2.29289C15.4804 2.10536 15.7348 2 16 2H21C21.2652 2 21.5196 2.10536 21.7071 2.29289C21.8946 2.48043 22 2.73478 22 3C22.0017 4.59079 22.6343 6.11595 23.7592 7.24081C24.884 8.36567 26.4092 8.99835 28 9C28.2652 9 28.5196 9.10536 28.7071 9.29289C28.8946 9.48043 29 9.73478 29 10Z",
					fill: "currentColor"
				})
			})
		})
	})
});
export default SvgStreamPlatformTiktok;
